import { Phone } from "lucide-react";
import { CONTACT } from "../data/content";

export const FloatingCTA = () => {
  return (
    <a
      data-testid="floating-phone-button"
      href={`tel:${CONTACT.phoneRaw}`}
      aria-label="Call Mad Props Marine now"
      className="pulse-ring fixed bottom-6 right-6 sm:bottom-8 sm:right-8 z-50 h-14 w-14 sm:h-16 sm:w-16 rounded-full bg-[#e85d04] hover:bg-[#dc2f02] text-white flex items-center justify-center shadow-2xl shadow-[#e85d04]/30 transition-colors duration-300"
    >
      <Phone size={24} className="sm:hidden" />
      <Phone size={26} className="hidden sm:block" />
    </a>
  );
};
